/* eslint-disable */
import HttpService from '../HttpService'

export default class FieldTypeService {
  constructor() {
    this._httpService = new HttpService('/sdi/field/type');
  }

  async FindAll() {
    return await this._httpService.get('');
  }
}
